import editMemberHeader from '@/components/partials/editMemberHeader/editMemberHeader.vue';

export default {
  name: 'editMember',
  components: {
    editMemberHeader,
  },
}